"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowBlockedError = void 0;
class WindowBlockedError extends Error {
    constructor(message) {
        super(message);
        // We need to explicitly set the prototype for this to be
        // labelled as a WindowBlockedError instead of Error
        // see. https://github.com/facebook/jest/issues/8279#issuecomment-539775425
        Object.setPrototypeOf(this, WindowBlockedError.prototype);
    }
}
exports.WindowBlockedError = WindowBlockedError;
